import { AtomField } from 'atoms/form-atoms';
import { TextInput, TextInputProps, Layer } from '@carbon/react';
import { useAtom } from 'jotai';

interface StringFieldProps extends Omit<TextInputProps, 'value' | 'light'> {
  field: AtomField<string>;
  light?: boolean;
}

const StringField = ({ field, light, ...rest }: StringFieldProps) => {
  const [fieldState, setValue] = useAtom(field);

  const textInput = (
    <TextInput
      {...rest}
      value={fieldState.value}
      onChange={(event) => setValue(event.target.value)}
      invalid={!fieldState.isValid}
      invalidText={!fieldState.isValid ? fieldState.error : ''}
    />
  );

  return light ? <Layer>{textInput}</Layer> : textInput;
};

export { StringField };
